import script from "./LayoutDefault.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutDefault.vue?vue&type=script&setup=true&lang=js"

import "./LayoutDefault.vue?vue&type=style&index=0&id=e7b9aaa4&lang=scss"

const __exports__ = script;

export default __exports__